export enum LocationType {
    Posebno = -1,
    Nedefinirano = 0,
    Nepokretna = 1,
    Vozilo = 2,
    Plovilo = 3
}